import React from 'react';
import { withTranslation, Trans, withNamespaces } from 'react-i18next';

import '../css/banner-style.css';

const BannerComponent = ({ bannerData }) => {

    const hitUrl = (e, url) => {
        e.preventDefault();
        window.location.href = url;
    }
    
    return(
        <>
            <div className="bnr-parcel-track-list-outer" onClick={(e) => hitUrl(e, bannerData.url)}>
                <div className="bnr-parcel-track-list-inner" style={{overFlow: 'hidden'}}>
                    
                    {bannerData.background_image == '' ?
                        ""
                    : 
                        <div 
                            className="bnr-image-block" 
                            style={{ 
                                backgroundImage: `url(/common/${bannerData.background_image})`, 
                                backgroundRepeat: "no-repeat" 
                            }}
                        >
                            <ul className="bnr-wishlist" ></ul>
                            <em >
                                {
                                    bannerData.image != '' ? 
                                        <img 
                                            src={`/common/${bannerData.image}`}
                                            alt="Order Item" 
                                        />
                                    :
                                        ""
                                }
                            </em>
                        </div>
                    }
                        
                    <div 
                        className={`bnr-content-block ${bannerData.background_image == '' ? "centered fullHeight items-see-more" : "heightHalf"}`}
                        style={{
                            // height: `${bannerData.background_image == ? '100%' : '41%'}` , 
                            backgroundColor: `${bannerData.background_color}`
                        }}
                    >
                        <ul>
                            {bannerData.title != '' 
                            ? 
                                <li className="title">
                                    <div dangerouslySetInnerHTML={{__html: bannerData.title}} />
                                </li>
                            :
                            ""
                        }
                            {bannerData.description != '' 
                            ? 
                                <li className="description" >
                                    <div dangerouslySetInnerHTML={{__html: bannerData.description}} />
                                    {/* {bannerData.description.replace( /(<([^>]+)>)/ig, '')} */}
                                </li>
                            :
                                ""
                            }
                            
                        </ul>
                        <div className="card-btn">
                            
                        </div>
                    </div>

                </div>
            </div>
        </>
    );
}

export default withTranslation()(BannerComponent);